<script>
    import { scale } from 'svelte/transition';
    import { createEventDispatcher } from "svelte";
    
    export let placeholder="", value="", icon=false, type="text", min=-80, max=200, error=false, width='240px';
    
    const dispatch = createEventDispatcher();
    
    const on_keydown = e => {
        e = e || window.event;
        dispatch("keypress", { e: e });
    };
    
    </script>
    
    <!-- svelte-ignore a11y-label-has-associated-control -->
    <div class:error style="width:{width}" in:scale|local="{{duration: 200}}" on:keydown={on_keydown} >
        {#if icon}
            <label>
                <svelte:component this={icon} />
            </label>
        {/if}
        {#if type==='email'}
        <input bind:value {placeholder} class:icon type="email" {min} {max}>
        {:else if  type==='password'}
            <input bind:value {placeholder} class:icon type="password" {min} {max}>
        {:else if  type==='time'}
            <input bind:value {placeholder} class:icon type="time">
        {:else if  type==='number'}
            <input bind:value {placeholder} class:icon type="number" {min}>
        {:else}
            <input bind:value {placeholder} class:icon >
        {/if}
    </div>
    
    <style>
    div {
        position: relative;
        max-width: var(--input-max-width);
        height: var(--input-height);
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto var(--vertical-comp-margin) auto;
    }
    
    .error input {
        border-color: red;
    }
    
    label {
        position: absolute;
        left: 0;
        width: var(--input-height);
        height: var(--input-height);
        background-color: rgba(0, 0, 0, 0);
        display: flex;
        justify-content: center;
        align-items: center;

    }
    
    input {
        height: 100%;
        width: 100%;
        max-width: var(--input-max-width);
        border: 1px solid currentColor;
        transition: border 0.1s;
        padding: 2px 5px;

    }
    
    input:hover {
        border: 1px solid gray;
    }
    
    input:focus {
        border: 1px solid var(--color_scheme-contrast_color);
    }
    
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
        border: 1px solid var(--color_scheme-text);
    }
    
    input[type="time"] {
        position: relative;
    }
    
    input[type="time"]::-webkit-calendar-picker-indicator {
        position: absolute;
        background: none;
        width: 100%;
        height: 100%;
        margin: 0;
        left: 0;
        padding: 0;
    }
    input[type="time"]::-webkit-datetime-edit {
        display: inline-flex;
        justify-content: center;
    }
    
    input[type="number"]::-webkit-inner-spin-button {
        display: none;
    }
    
    input.icon {
        padding-left: var(--input-height);
    }
    
    </style>
    